import { Spinner, SpinnerProps, Flex, FlexProps } from '@chakra-ui/react';

const Loading = ({
  size = 'lg',
  ...props
}: FlexProps & Pick<SpinnerProps, 'size'>) => (
  <Flex
    width="100%"
    height="100%"
    alignItems="center"
    justifyContent="center"
    minHeight="300px"
    {...props}
  >
    <Spinner size={size} />
  </Flex>
);

export default Loading;
